export * from 'stores/search-base/mutation-types';
export const SET_TRACK_NEXT_SEARCH = 'SET_TRACK_NEXT_SEARCH';
